import React from "react";
import InstallView from "../../../views/installations/install";

const Install = () => {
  return <InstallView />;
};

export default Install;
